import './index.css'

import { ToastViewport } from '@bak/admin-ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AdminUiBridge } from './i18n/AdminUiBridge.js'
import { I18nProvider } from './i18n/index.js'
import { createAppRouter } from './router.js'

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } })
const router = createAppRouter(queryClient)

const root = document.getElementById('root')
if (!root) throw new Error('#root missing')

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <AdminUiBridge>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <ToastViewport />
        </QueryClientProvider>
      </AdminUiBridge>
    </I18nProvider>
  </StrictMode>,
)
